export type GroupBonusTier = {
  min_avg: number;
  max_avg: number | null;
  amount: number;
};

// Right edge of tier `idx` in an equal-segment layout (e.g., 3 tiers
// → 33 / 66 / 99). The 99 (vs 100) keeps the last label visible inside
// the bar instead of clipping at the right edge.
export function tierMarkPct(idx: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round(((idx + 1) * 99) / total);
}

export function currentTierIndex(tiers: GroupBonusTier[], avg: number): number {
  for (let i = tiers.length - 1; i >= 0; i--) {
    const t = tiers[i]!;
    if (avg >= t.min_avg) return i;
  }
  return -1;
}

export function nextTier(
  tiers: GroupBonusTier[],
  avg: number
): GroupBonusTier | null {
  for (let i = 0; i < tiers.length; i++) {
    const t = tiers[i]!;
    if (avg < t.min_avg) return t;
  }
  return null;
}
